import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledArrow = styled(BaseSvg)`
  height: 1rem;
  width: 1rem;
  color: #8e8e8e;
`

const ArrowRight = ({ title = 'Arrow Right', ...rest }: IconProps) => (
  <StyledArrow viewBox="0 0 35.414 35.414" title={title} {...rest}>
    <polygon
      stroke="currentColor"
      strokeWidth="4px"
      points="27.051,17 9.905,0 8.417,1.414 24.674,17.707 8.363,34 9.914,35.414 27.051,18.414"
    />
  </StyledArrow>
)

ArrowRight.needsWork = true
ArrowRight.displayName = 'ArrowRight'
export default ArrowRight
